<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <app-product-adder></app-product-adder>
</ion-app>
